/*
 * NOVESTA Judge.me default sort
 * Version: v1.3
 * Updated: 2026-07-23 01:39 JST
 * Keeps latest sorting without moving the initial product-page viewport to Judge.me.
 */

(() => {
  let hasRequestedMostRecent = false;
  let observer;

  const arrangeToolbar = () => {
    const widget = document.querySelector('.jdgm-review-widget');
    const searchRow = widget?.querySelector('.jdgm-row-search');
    const actionsRow = widget?.querySelector('.jdgm-row-actions');

    if (!searchRow || !actionsRow) return false;

    if (searchRow.parentElement !== actionsRow) {
      actionsRow.prepend(searchRow);
    }

    actionsRow.dataset.novestaToolbar = 'true';
    return true;
  };

  const arrangeMedal = () => {
    const widget = document.querySelector('.jdgm-review-widget');
    const starsRow = widget?.querySelector('.jdgm-row-stars');
    const medal = widget?.querySelector('.jdgm-medals-wrapper');
    const actions = starsRow?.querySelector('.jdgm-widget-actions-wrapper');

    if (!starsRow || !medal || !actions) return false;

    if (medal.parentElement !== starsRow || medal.nextElementSibling !== actions) {
      starsRow.insertBefore(medal, actions);
    }

    medal.dataset.novestaMedalPosition = 'header';
    return true;
  };

  const refreshMostRecentWithoutJump = (sort) => {
    const startX = window.scrollX;
    const startY = window.scrollY;
    const cancelEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    let cancelled = false;
    let cleanupTimer;

    const cleanup = () => {
      window.removeEventListener('scroll', restoreScroll);
      cancelEvents.forEach((eventName) => {
        window.removeEventListener(eventName, cancelRestore, true);
      });
      window.clearTimeout(cleanupTimer);
    };

    const cancelRestore = () => {
      cancelled = true;
      cleanup();
    };

    const restoreScroll = () => {
      if (!cancelled) {
        window.scrollTo(startX, startY);
      }
      cleanup();
    };

    cancelEvents.forEach((eventName) => {
      window.addEventListener(eventName, cancelRestore, {
        once: true,
        capture: true,
        passive: true,
      });
    });
    window.addEventListener('scroll', restoreScroll, {
      once: true,
      passive: true,
    });
    cleanupTimer = window.setTimeout(cleanup, 1200);

    sort.value = 'most-recent';
    sort.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const requestMostRecent = () => {
    if (hasRequestedMostRecent) return true;

    const sort = document.querySelector(
      '.jdgm-review-widget select.jdgm-sort-dropdown'
    );
    const mostRecentOption = sort?.querySelector(
      'option[value="most-recent"]'
    );

    if (!sort || !mostRecentOption) return false;

    hasRequestedMostRecent = true;

    if (sort.value === 'most-recent') return true;

    refreshMostRecentWithoutJump(sort);
    return true;
  };

  const enhanceWidget = () => {
    arrangeToolbar();
    arrangeMedal();
    requestMostRecent();
  };

  const initialize = () => {
    enhanceWidget();

    observer = new MutationObserver(enhanceWidget);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
